module.exports = __webpack_public_path__ + "static/media/icon-user-gray.ecea474c.svg";